import BENEFICIARY_SUBJECT_TYPE_KEY from '@Domain/Subjects/BeneficiarySubjectTypeKey';
import buildSubjectListPath from '@UI/Pages/Beneficiaries/Shared/Helpers/buildSubjectListPath';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import InterviewConsentContent from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/Creations/CreateInterviewConsentPage/InterviewConsentContent';
import InterviewsNotifications from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/InterviewsNotifications';
import useSubjectAddressParams from '@UI/Pages/Beneficiaries/Hooks/Params/useSubjectAddressParams';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Mounted from `…/:dossier/interviews/new/interview?preparation=ID`: the consent
 * screen, the first step of recording a conversation for a preparation. An invalid dossier address
 * redirects to the beneficiary list; the preparation is resolved by the content.
 */
const CreateInterviewConsentPage: React.FC = () => {
	const navigate = useNavigate();
	const { subject } = useSubjectAddressParams();

	React.useEffect(() => {
		if (subject === null) {
			navigate(buildSubjectListPath(BENEFICIARY_SUBJECT_TYPE_KEY));
		}
	}, [subject, navigate]);

	return (
		<React.Fragment>
			<ConditionalLoader data={subject}>
				{(address) => <InterviewConsentContent subject={address} />}
			</ConditionalLoader>
			<InterviewsNotifications />
		</React.Fragment>
	);
};

export default CreateInterviewConsentPage;
